import {
  importLibrary,
  setOptions,
  type APIOptions,
} from '@googlemaps/js-api-loader';

let isConfigured = false;

/**
 * Configures the shared Google Maps JS API loader.
 *
 * The v2 loader uses functional API instead of the deprecated Loader class.
 */
export default function useGoogleMaps(
  apiKey: string,
  options: Partial<Omit<APIOptions, 'key'>> = {},
) {
  if (!isConfigured) {
    setOptions({
      key: apiKey,
      libraries: ['places'],
      ...options,
    });

    isConfigured = true;
  }

  return {
    importLibrary,
  };
}
